import React, { Fragment, useState } from 'react';
import { useForm } from "react-hook-form";
import Modal from 'react-bootstrap/Modal'
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import './layout.css';

// API endpoint - configure in .env as REACT_APP_CONTACT_API_URL
const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || 'https://9hcys35u6b.execute-api.us-east-1.amazonaws.com/prod/submit';

// Business configuration for Variable Assign
const BUSINESS_CONFIG = {
    businessId: 'variable-assign',
    businessName: 'Variable Assign',
    businessEmail: 'info@variableassign.com',
    domain: 'variableassign.com'
};

const ModalSignUpForm = ({ show, onClose }) => {

    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const SERVICE_LABELS = {
        'ai-integration': 'AI Integration into Existing Systems',
        'ml-development': 'Machine Learning Model Development',
        'ai-consulting': 'AI Strategy Consulting',
        'staff-augmentation': 'AI/ML Engineer Staffing',
        'training': 'AI Training for Your Team',
        'other': 'Other'
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        setError(null);

        // Build message from form fields
        const serviceLabel = SERVICE_LABELS[data.serviceType] || data.serviceType;
        const message = `
Service Requested: ${serviceLabel}
Timeline: ${data.projectTimeline || 'Not specified'}

Project Details:
${data.projectDetails || 'No details provided'}
        `.trim();

        // Map form data to microservice format
        const payload = {
            // Business identification
            ...BUSINESS_CONFIG,

            // Required contact fields
            name: data.contactName,
            email: data.Email,
            message: message,

            // Optional fields
            phone: data.phone_number || undefined,
            company: data.companyName,
            subject: `Consultation Request: ${serviceLabel}`,

            // Additional fields for tracking
            serviceType: data.serviceType,
            projectTimeline: data.projectTimeline
        };

        try {
            const response = await fetch(CONTACT_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || 'Failed to submit form');
            }

            console.log('Form submitted successfully:', result);
            setSubmitted(true);
            reset();
        } catch (err) {
            console.error('Form submission error:', err);
            setError(err.message || 'Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const onButton = (e) => {
        e.preventDefault();
        handleSubmit(onSubmit)();
    };

    const handleClose = () => {
        setSubmitted(false);
        setError(null);
        onClose();
    };

    return (
        <Fragment>

            <Modal
                dialogClassName="modal-45w"
                show={show}
                onHide={handleClose}>
                <ModalHeader closeButton>
                    <ModalTitle>Schedule a Consultation</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {submitted ? (
                        <div className="text-center p-4">
                            <i className="fa fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
                            <h3 className="mt-3">Thank You!</h3>
                            <p>Your consultation request has been submitted successfully. Our team will contact you within 24-48 hours.</p>
                            <button className="btn btn-default mt-3" onClick={handleClose}>Close</button>
                        </div>
                    ) : (
                    <div className="main object-non-visible animated object-visible fadeInUpSmall" data-animation-effect="fadeInUpSmall" data-effect-delay="100">
                        <div className="form-block p-30 form-subscriber  border-clear">
                            {error && (
                                <div className="alert alert-danger mb-3">
                                    <i className="fa fa-exclamation-circle mr-2"></i>
                                    {error}
                                </div>
                            )}

                            <form id="contact-form"
                                className="form-horizontal"
                                onSubmit={handleSubmit(onSubmit)} >
                                <div className="mb-3 has-feedback row">
                                    <label htmlFor="companyName" className="col-md-5 control-label text-md-right col-form-label">Company Name
                                        <span className="text-danger small">*</span>
                                    </label>
                                    <div className="col-md-7">
                                        <i className="fa fa-building form-control-feedback pr-4"></i>
                                        <input type="text" className="form-control" name="companyName" id="companyName" placeholder="Your Company"
                                            {...register("companyName", {
                                                required: true
                                              })} />
                                    </div>
                                </div>
                                <div className="mb-3 has-feedback row">
                                    <label htmlFor="contactName" className="col-md-5 control-label text-md-right col-form-label">Contact Name
                                        <span className="text-danger small">*</span>
                                    </label>
                                    <div className="col-md-7">
                                        <i className="fa fa-user form-control-feedback pr-4"></i>
                                        <input type="text" className="form-control" name="contactName" id="contactName" placeholder="Your Name"
                                            {...register("contactName", {
                                                required: true
                                              })} />
                                    </div>
                                </div>
                                <div className="mb-3 has-feedback row">
                                    <label htmlFor="inputEmail" className="col-md-5 control-label text-md-right col-form-label">Work Email
                                        <span className="text-danger small">*</span>
                                    </label>
                                    <div className="col-md-7">
                                        <i className="fa fa-envelope form-control-feedback pr-4"></i>
                                        <input type="email" className="form-control" name="inputEmail" id="inputEmail" placeholder="you@company.com"
                                            {...register("Email", {
                                                required: true,
                                                pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
                                            })} />
                                    </div>
                                </div>
                                <div className="mb-3 has-feedback row">
                                    <label htmlFor="phone_number" className="col-md-5 control-label text-md-right col-form-label">Phone Number
                                    </label>
                                    <div className="col-md-7">
                                        <i className="fa fa-phone form-control-feedback pr-4"></i>
                                        <input type="tel" className="form-control" name="phone_number" id="phone_number" placeholder="(919) 555-5555"
                                            {...register("phone_number")} />
                                    </div>
                                </div>
                                <div className="mb-3 has-feedback row">
                                    <label htmlFor="serviceType" className="col-md-5 control-label text-md-right col-form-label">What do you need?
                                        <span className="text-danger small">*</span>
                                    </label>
                                    <div className="col-md-7">
                                        <select className="form-control" name="serviceType" id="serviceType"
                                            {...register("serviceType", { required: true })}>
                                            <option value="">Select a service</option>
                                            <option value="ai-integration">AI Integration into Existing Systems</option>
                                            <option value="ml-development">Machine Learning Model Development</option>
                                            <option value="ai-consulting">AI Strategy Consulting</option>
                                            <option value="staff-augmentation">AI/ML Engineer Staffing</option>
                                            <option value="training">AI Training for Your Team</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="mb-3 has-feedback row">
                                    <label htmlFor="projectTimeline" className="col-md-5 control-label text-md-right col-form-label">Project Timeline
                                    </label>
                                    <div className="col-md-7">
                                        <select className="form-control" name="projectTimeline" id="projectTimeline"
                                            {...register("projectTimeline")}>
                                            <option value="immediate">Immediate - Ready to start</option>
                                            <option value="1-3months">1-3 months</option>
                                            <option value="3-6months">3-6 months</option>
                                            <option value="exploring">Just exploring options</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="mb-3 has-feedback row">
                                    <label htmlFor="projectDetails" className="col-md-5 control-label text-md-right col-form-label">Tell us about your project
                                    </label>
                                    <div className="col-md-7">
                                        <textarea className="form-control" name="projectDetails" id="projectDetails" rows="3"
                                            placeholder="Briefly describe your AI goals or challenges..."
                                            {...register("projectDetails")} />
                                    </div>
                                </div>

                                <div className="mb-3 has-feedback row">
                                    <div className="ml-md-auto col-md-12">
                                        <div className="signup-agree form-check">
                                            <label className="form-check-label">
                                                By submitting, you agree to our
                                                <a href="/#"> Terms of Service </a>and
                                                <a href="/#"> Privacy Policy</a>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3 row modal-footer modal-footer-content">
                                    <button
                                        onClick={onButton}
                                        className="btn btn-group btn-default btn-animated"
                                        disabled={isLoading}>
                                        {isLoading ? (
                                            <>
                                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                                Submitting...
                                            </>
                                        ) : (
                                            <>
                                                Request Consultation
                                                <i className="fa fa-arrow-right"></i>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    )}
                </ModalBody>

            </Modal>

        </Fragment >
    )
}

export default ModalSignUpForm
